
const defaultAttrs = {"width":"16","height":"20","fill":"none","viewBox":"0 0 16 20"};
const svgInner = "<path fill=\"transparent\" stroke=\"#333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m1 1 14 9-14 9z\"/>";

export default function PreviewPlaySvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
